import valueIn from '../../utils/valueIn';
import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
    id: 'BEACH_DISTANCE',
    analyticsName: 'Beach',
    queryKey: 'f_beach_dist',
    type: FILTER_TYPES.DISTANCE,
    caId: 'distanceToNearestBeach',
    bucketify: (hotel) => {
        const distanceFacts = hotel?.distanceFacts;
    // TODO: lift the id somewhere else?
        const distanceFact = distanceFacts && distanceFacts.find(fact => {
            return fact?.id === 'distanceToNearestBeach';
        });

        if (!distanceFact) {
            return undefined;
        }

    // TODO: put the id somewhere else (also for price)!
        return {
            bucketId: 'hasDistance',
            bucketName: 'distanceToNearestBeach',
        };
    },
    decorateFinalState: (finalState, filterTree, memory, { steps }) => {
        finalState.values = finalState.values || {};
        finalState.values.maximumDistance = steps[steps.length - 1];
    },
    toQuery: ({ value }, filterStateValues) => {
        const maximumDistance = valueIn(filterStateValues, 'maximumDistance');
        return value && value < maximumDistance ? value : undefined;
    },
    fromQuery: (rawQueryValue) => {
        return {
            selectedDistance: +rawQueryValue,
        };
    },
    reset: (currentState) => {
    // NB: We do not want to save selectedDistance since the filter is reset
    //     (slider set to max)
        return {
            hasDistance: currentState?.hasDistance,
            maximumDistance: currentState?.maximumDistance,
        };
    },
}));
